div.iconCircle {
	width: 39px;
	height: 22px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 10px;
	margin-right: 6px;
}

.iconCircle.number {
	font-size: 15px;
	font-weight: 400;
	color: #42296e;
	line-height: 1;
	text-align: center;
	background: #e9e3f2;
	border: 1px solid #dad0ea;
}
